import '../media/css/AppModeSwitcher.css';
import React from 'react';
import {Button, ButtonGroup, ButtonToolbar, UncontrolledTooltip} from "reactstrap";

const AppModeSwitcher = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.state.body = window.document.getElementsByTagName('body')[0];
		if ( window.localStorage && typeof window.localStorage.getItem('highReadability') !== "undefined" ) {
			const nd = (parseInt(window.localStorage.getItem('highReadability')) === 1);
			this.state.highReadability = nd;
			if ( nd && !  this.state.body.classList.contains('highReadability') ) this.state.body.classList.add('highReadability');
		} else {
			this.state.highReadability = this.state.body.classList.contains('highReadability');
		}
		this.toggleHighReadability = this.toggleHighReadability.bind(this);
		this.uid = "AppModeSwitcher-"+ window.glob.generateUid();
	}
	toggleHighReadability(nd = ! this.state.highReadability) {
		if ( nd ) {
			this.state.body.classList.add('highReadability');
			if ( window.localStorage ) window.localStorage.setItem('highReadability',1);
		} else {
			this.state.body.classList.remove('highReadability');
			if ( window.localStorage ) window.localStorage.setItem('highReadability',0);
		}
		this.setState({ highReadability: nd });
	}
	render() {
		return(
			<div className={"AppModeSwitcher"} id={this.uid}>
				<div>
					Visualizzazione
				</div>
				<ButtonToolbar>
					<ButtonGroup>
						<Button
							color={ this.state.highReadability ? "light" : "secondary" }
							className={"alwaysCompact"}
							onClick={ ()=>{ this.toggleHighReadability(false); } }
							active={ true }
							id={this.uid+"-Button-compact"}
						>
							Compatta
						</Button>
						<Button
							color={ this.state.highReadability ?"secondary" : "light" }
							className={"alwaysHighReadability"}
							onClick={ ()=>{ this.toggleHighReadability(true); } }
							active={ true }
							id={this.uid+"-Button-hi"}
						>
							Alta leggibilità
						</Button>
					</ButtonGroup>
				</ButtonToolbar>
				<UncontrolledTooltip target={"#"+this.uid+"-Button-compact"}>
					Visualizzazione ottimizzata per schermi piccoli
				</UncontrolledTooltip>
				<UncontrolledTooltip target={"#"+this.uid+"-Button-hi"}>
					Visualizzazione con font specificatamente progettati per l’alta leggibiità
				</UncontrolledTooltip>
			</div>
		);
	}
}

export default AppModeSwitcher;